import { Fetch } from 'lib';
import type { Purchase, PurchaseProductSummary } from 'types';

type RequestResponses = Purchase;

type RequestParameters = {
  id: string;
};

type RequestBody = Prettify<
  Pick<Purchase, 'status'> &
    Record<'purchaseProducts', PurchaseProductSummary[]>
>;

const updatePurchase = async (params: RequestParameters, body: RequestBody) =>
  await Fetch<RequestResponses, RequestParameters, RequestBody>({
    url: 'adminPurchase/updatePurchase',
    method: 'PUT',
    params,
    body,
  });

export { updatePurchase };
